import CommonPopover from '@shared/components/ui/CommonPopover';
import { Dispatch, FC, SetStateAction } from 'react';
import DefectSelectorMenu from './DefectSelectorMenu';
import { Box, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UtmsButton from '@shared/components/ui/UtmsButton';
import { Defect } from '../types';

interface DefectsPopoverProps {
    anchorEl: HTMLElement | null;
    setAnchorEl: Dispatch<SetStateAction<HTMLElement | null>>;
    defects: Defect[];
}

const DefectsPopover: FC<DefectsPopoverProps> = ({ anchorEl, setAnchorEl, defects }) => {
    const { t } = useTranslation();

    return (
        <CommonPopover anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
            <Box sx={{ width: 600 }}>
                <DialogTitle sx={{ fontSize: 16, fontWeight: 700 }}>{t('defects')}</DialogTitle>
                <DialogContent sx={{ overflow: 'visible' }}>
                    <DefectSelectorMenu
                        open={Boolean(anchorEl)}
                        onClose={() => setAnchorEl(null)}
                        readOnly
                        defects={defects}
                    />
                </DialogContent>
                <DialogActions>
                    <UtmsButton onClick={() => setAnchorEl(null)}>{t('close')}</UtmsButton>
                </DialogActions>
            </Box>
        </CommonPopover>
    );
};

export default DefectsPopover;
